module.exports = __webpack_public_path__ + "193af3435aaea410011ed7a12c624637.jpg";